
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.707 15.983"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_30414","data-name":"Group 30414","transform":"translate(.6 .6)","fill":"none","stroke":"#5a677d","stroke-linejoin":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"Path_19936","data-name":"Path 19936","d":"M742.375 332.338l-8.529 4.8-8.978-4.8 8.978-4.7z","transform":"translate(-724.868 -327.643)"}}),_c('path',{attrs:{"id":"Path_19937","data-name":"Path 19937","d":"M733.622 332.293l4.212 2.589v7.543","transform":"translate(-724.868 -327.643)","stroke-linecap":"round"}}),_c('path',{attrs:{"id":"Path_19938","data-name":"Path 19938","d":"M741.689 334.17l.04 1.632c.046 1.9-.055 3.117-1.884 3.938-1.48.664-4.189 2.57-5.116 2.581-.976.012-2.813-1.434-4.4-2.136a4.741 4.741 0 01-2.9-4.3v-1.715","transform":"translate(-725.631 -328.683)"}})])])
          )
        }
      }
    